import { Button } from "@aircall/ds";
import { Pencil } from "@aircall/react-icons";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section/Section";

export function PlaygroundSectionTags() {
  return (
    <Section data-test="tags-section">
      <SectionHeader>
        <SectionTitle>Tags</SectionTitle>
      </SectionHeader>
      <div className="flex items-center gap-4">
        <div className="flex flex-wrap gap-2">
          <span className="rounded-full bg-muted px-2 py-0.5 text-xs font-normal text-foreground">
            Support
          </span>
          <span className="rounded-full bg-muted px-2 py-0.5 text-xs font-normal text-foreground">
            Billing
          </span>
        </div>
        <Button size="icon-sm" variant="ghost">
          <Pencil className="size-4" />
        </Button>
      </div>
    </Section>
  );
}
